export default __webpack_public_path__ + "static/article-saving-for-financial-freedom-v1-5b5b44e73c353b32a95bae32b3d3c4f6.jpg";